module.exports = __webpack_public_path__ + "img/20201126.459e10a8.png";